/********************************************************************************
Filename: np-carousel.js
Created: 31 Oct 2022
Author: Ron Robertson
Description: Hero carousel that cycles slides
Usage Example:
<np-carousel>
    <np-carousel-slide></np-carousel-slide>
    <np-carousel-slide></np-carousel-slide>
    <np-carousel-slide></np-carousel-slide>
</np-carousel>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
        #carousel{
            height: 270px;
            aspect-ratio: 16/9;
            position: relative;
            overflow: hidden;
          }
          .slidesWrapper{
          }
          ::slotted(*){
            position: absolute;
            top:0px;
            left: 100%;
            width: 100%;
            height: 100%;
            transform: translateX(0);
            animation-duration: 1.3s;
            animation-fill-mode: forwards;
          }
          ::slotted(*.cycleOutLeft){
            animation-name: slideOutLeft;
          }

          ::slotted(*.cycleOutRight){
            animation-name: slideOutRight;
          }

          ::slotted(*.cycleInLeft){
            animation-name: slideInLeft;
          }

          ::slotted(*.cycleInRight){
            animation-name: slideInRight;
          }

          ::slotted(*.displayed){
            left:0px;
          }
          ::slotted(*.left){
            left: calc(100% * -1);
          }
          ::slotted(*.right) {
            left: 100%;
          }

          #carouselNav{
            position:absolute;
            bottom: 20px;
            right: 0px;
            left: 0px;
            margin-left: auto;
            margin-right: auto;
            width: calc((var(--col-width) * 6) + (var(--gutter-width) * 5));
            display: flex;
            justify-content: flex-end;
            z-index: 180;
            pointer-events: none;
            column-gap: 38px;
          }
          #carouselNav.hide{
            display:none;
          }

          #carouselNav a{
            width: 10px;
            display: inline-block;
            pointer-events: all;
          }
          #carouselNav a:first-child{
            margin-right: 10px;
          }

          @keyframes slideOutLeft {
            0% {transform: translateX(0px);}
            70% {transform: translateX(-100%);}
            100% {transform: translateX(-100%);}
        }
        @keyframes slideOutRight {
            0% {transform: translateX(0px);}
            70% {transform: translateX(100%);}
            100% {transform: translateX(100%);}
        }
        @keyframes slideInLeft {
            0% {transform: translateX(0px);}
            70% {transform: translateX(-100%);}
            100% {transform: translateX(-100%);}
        }
        @keyframes slideInRight {
            0% {transform: translateX(0px);}
            70% {transform: translateX(100%);}
            100% {transform: translateX(100%);}
        }


        @media screen and (min-width: 480px) {
            #carousel{
                height: 432px;
            }
        }
        @media screen and (min-width: 768px) {
            #carousel{
                height: 540px;
            }
            #carousel #carouselNav{
                width: calc((var(--col-width) * 12) + (var(--gutter-width) * 11));
            }
            #carouselNav{
                bottom: 40px;
            }
            #carouselNav a{
                width: 20px;
            }
        }
        @media screen and (min-width: 960px) {
            #carousel{
                height: 675px;
            }
        }
        @media screen and (min-width: 1200px) {
            #carousel #carouselNav{
                width: calc((var(--col-width) * 10) + (var(--gutter-width) * 11));
                max-width: 995px;
            }
        }
        @media screen and (min-width: 1920px) {

        }

        </style>

        <div id="carousel">
          <div class="slidesWrapper">
            <slot></slot>
          </div><!--END slidesWrapper-->
          <div id="carouselNav">
              <a id="carouselPrev" href="">
                  <svg viewBox="0 0 50 80" >
                      <polyline fill="none" stroke="#ffffff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" points="
                      45.63,75.8 0.375,38.087 45.63,0.375 "/>
                  </svg>
              </a>
              <a id="carouselNext" href="">
                  <svg viewBox="0 0 50 80" >
                      <polyline fill="none" stroke="#ffffff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" points="
                      0.375,0.375 45.63,38.087 0.375,75.8 "/>
                  </svg>
              </a>
          </div><!--END carouselNav-->
        </div><!--END carousel-->
    `;

    class NpCarousel extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            this.carouselCycle = this.carouselCycle.bind(this);
            this.carouselCycleNext = this.carouselCycleNext.bind(this);
            this.carouselCyclePrev = this.carouselCyclePrev.bind(this);
            this.startCarouselInterval = this.startCarouselInterval.bind(this);
            this.stopCarouselInterval = this.stopCarouselInterval.bind(this);
            this.initializeSlides = this.initializeSlides.bind(this);

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.carouselEle = this.shadowRoot.getElementById("carousel");
            this.carouselNavEle = this.shadowRoot.getElementById("carouselNav");
            this.carouselPrevTrigger = this.shadowRoot.getElementById("carouselPrev");
            this.carouselNextTrigger = this.shadowRoot.getElementById("carouselNext");

            this.slidesArray = [];

            //carouselInterval
            this.carouselInterval;

            // slot change event
            this.shadowRoot.addEventListener('slotchange', this.initializeSlides);

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            /*
            if (!this.hasAttribute('myattribute')) {
                this.setAttribute('myattribute', "value");
            }
            */

            /* Set Event Listeners */
            this.carouselPrevTrigger.addEventListener('click', this.carouselCyclePrev);
            this.carouselNextTrigger.addEventListener('click', this.carouselCycleNext);
            this.carouselEle.addEventListener('mouseenter', this.stopCarouselInterval);
            this.carouselEle.addEventListener('mouseleave', this.startCarouselInterval);

            this.initializeSlides();

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        /*
        static get observedAttributes() {
            return ['myattribute'];
        }
        */

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {
        /*
        if(name === 'myattribute') {
            this.myBtn.setAttribute("value", newValue);
        }
        */
       }/* END attributesChangedCallback */

      /* Getting attributes */
      /*
      get value() {
        return this.getAttribute('value');
      }
      */

      /* Settinng attributes */
      /*
      set value(newValue) {
        this.setAttribute('value', newValue);
      }
      */

      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
      }

        /* Method */
      //cycle the carousel to the left or right depending on direction passed
      carouselCycle(direction='right') {

        /* get reference to slides */
        let slot = this.shadowRoot.querySelector('slot');

        //get currently displayed slide
        //let allSlides = this.carouselEle.querySelectorAll("np-carousel-slide");
        let allSlides = slot.assignedElements();
        let currentSlide;
        let nextSlide;
        let prevSlide;

        for(var s = 0; s < allSlides.length; s++) {

          if(allSlides[s].classList.contains('displayed')) {
            currentSlide = allSlides[s];
            nextSlide = allSlides[s+1];
          }
        }


        // let currentSlide = allSlides.querySelector(".displayed");
        // let nextSlide;

        if(direction =='right'){
          //check if this slide has a next sibling
          if(currentSlide.nextElementSibling && currentSlide.nextElementSibling.id != "carouselNav"){
            //use the next sibling
            nextSlide = currentSlide.nextElementSibling;
          }else{
            //use the first element
            nextSlide = allSlides[0];
          }
        }else{
          //check if this slide has a previous sibling
          if(currentSlide.previousElementSibling && currentSlide.previousElementSibling.id != "carouselNav"){
            //use the previous sibling
            nextSlide = currentSlide.previousElementSibling;
          }else{
            //use the last element
            nextSlide = allSlides[allSlides.length -1];
          }
        }


        //apply classes
        if(direction == 'right'){
          //positioning classes
          nextSlide.classList.remove('left');
          nextSlide.classList.add('right');

          //animation classes
          currentSlide.classList.add('cycleOutLeft');
          nextSlide.classList.add('cycleInLeft');
        }else{
          //positioning classes
          nextSlide.classList.remove('right');
          nextSlide.classList.add('left');

          //animation classes
          currentSlide.classList.add('cycleOutRight');
          nextSlide.classList.add('cycleInRight');
        }

        //remove animation classes when animation ends on current slide
        currentSlide.addEventListener('animationend', (event) => {
          event.target.classList.remove('displayed');
          event.target.classList.remove('right');
          event.target.classList.remove('left');
          event.target.classList.remove('cycleOutRight');
          event.target.classList.remove('cycleOutLeft');
        }, { once: true });

        //remove animation classes when animation ends on next slide
        nextSlide.addEventListener('animationend', (event) => {
          event.target.classList.add('displayed');
          event.target.classList.remove('left');
          event.target.classList.remove('right');
          event.target.classList.remove('cycleInRight');
          event.target.classList.remove('cycleInLeft');
        }, { once: true });

      }

      //cycle the carousel to the right
      carouselCycleNext(event){
        event.preventDefault();
        this.carouselCycle('right');
      }

      //cycle the carousel to the left
      carouselCyclePrev(event){
        event.preventDefault();
        this.carouselCycle('left');
      }

      startCarouselInterval(){
        clearInterval(this.carouselInterval);

        /* get reference to slot */
        let slot = this.shadowRoot.querySelector('slot');
        // get reference to slides
        let allSlides = slot.assignedElements();

        if(allSlides.length > 1) {
          this.carouselInterval = setInterval(this.carouselCycle, 5000);
        }
      }
      stopCarouselInterval(){
        clearInterval(this.carouselInterval);
      }
      initializeSlides() {

        /* get reference to slot */
        let slot = this.shadowRoot.querySelector('slot');

        // get reference to slides
        let allSlides = slot.assignedElements();

        // if only one or less slides don't cycle
        if(allSlides.length <=1) {

          this.stopCarouselInterval();

          this.carouselNavEle.classList.add('hide');
        }else{
          this.carouselNavEle.classList.remove('hide');

          // start the interval
          this.startCarouselInterval();
        }
      }



    } /* END class */

    window.customElements.define('np-carousel', NpCarousel);

  })();
